var exports = {
  "SP": "FullscreenPanel__lXkuI2",
  "Zk": "Panel__p4IEsb",
  "UC": "Content__5Z9wEm",
};

module.exports = exports;
